const randomInt = (length) => Math.floor(Math.random() * length);

export { randomInt };
//# sourceMappingURL=random-int.js.map
